import React, {Component} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import 'slick-carousel';
import {AJAX, showPreloader, hidePreloader, getLocationDetailsById} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {getRentalCarPrices} from "./frontend_script";

class SearchResultPage extends Component {
	constructor(props) {
		super(props);
		this.onSendErrorLimit = this.onSendErrorLimit.bind(this);

		this.state = {
			error_limit_send: false
		};

	}

	componentDidUpdate() {
		if (this.props.scroll_to_element === 'id_vehicles_div') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				offset: window.offset_scroll_value(),
//				containerId: "id_scrolling_div"
			})
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}
	}

	onSendErrorLimit(e) {
		let fields = this.props.booking_field_list.error_limit;
		let btn = e.target;
		let form_inputs = $(btn).closest('.booking_limit');
		let params = {};
		let t = this;

		for (let item in fields) {
			let el = form_inputs.find('[name='+fields[item]+']');
			if (el.length) {
				params['booking['+fields[item]+']'] = el[0].value.trim();
			}
		}

		//validation

		params.action = 'api/booking/limit';

		AJAX(bf_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
				showPreloader();
			},
			func_callback: function (resp) {

				if(resp.error !== undefined)
					showPopupWithGoBack(resp.error);
				else if(resp.data !== undefined)
					showPopupWithGoBack('<img src="../../wp-content/plugins/booking-form/images/thumb-up-gecko.png" alt="gecko" style={{float:"left",margin:"0px 20px 0px 0px"}}>Your request has been sent. Thank you for choosing to Go with the Gecko.');

//				console.log(resp);

				t.setState({error_limit_send: true});

				hidePreloader();
			},
			func_error: function (resp) {
				hidePreloader();
				showPopupWithGoBack(resp.message);
			}
		});
	}

	render() {

		return (<>
			<RedirectOnlyHome />

			<div id={'id_vehicles_div'} className="vehicles" style={{marginBottom:"25px", marginTop:"30px"}}>
				<div className="row">
					{
						this.props.search_result.success ?
							(
								<div className="col">
									{
										(Object.keys(this.props.search_result.vehicles).length || Object.keys(this.props.search_result.vehicles_closest).length || Object.keys(this.props.search_result.vehicles_closest_date).length) ?
										(
											<>
												<AvailableVehicles
													vehicles={this.props.search_result.vehicles}
													vehicles_filter={this.props.search_result_filter.vehicles}
													vehicles_closest_date={this.props.search_result.vehicles_closest_date}
													vehicles_closest={this.props.search_result.vehicles_closest}
													booking_form_data={this.props.booking_form_data}
													to_show={this.props.to_show}
													category_group_filter={this.props.category_group_filter}
													handleSetHireIncludes={this.props.handleSetHireIncludes}
													handleSetShowData={this.props.handleSetShowData}
													handleSetSomeBlock={this.props.handleSetSomeBlock}
													handleSetFilterResult={this.props.handleSetFilterResult}
												/>
												{
													(Object.keys(this.props.search_result_filter.vehicles_closest_date).length > 0) &&
													(
														<AvailableVehiclesClosestDate
															vehicles_closest_date_filter={this.props.search_result_filter.vehicles_closest_date}
															booking_form_data={this.props.booking_form_data}
															to_show={this.props.to_show}
															category_group_filter={this.props.category_group_filter}
															handleSetHireIncludes={this.props.handleSetHireIncludes}
															handleSetShowData={this.props.handleSetShowData}
															handleSetSomeBlock={this.props.handleSetSomeBlock}
														/>
													)
												}
												{
													(Object.keys(this.props.search_result_filter.vehicles_closest).length > 0) &&
													(
														<AvailableVehiclesClosest
															vehicles_closest_filter={this.props.search_result_filter.vehicles_closest}
															booking_form_data={this.props.booking_form_data}
															to_show={this.props.to_show}
															category_group_filter={this.props.category_group_filter}
															handleSetHireIncludes={this.props.handleSetHireIncludes}
															handleSetShowData={this.props.handleSetShowData}
															handleSetSomeBlock={this.props.handleSetSomeBlock}
														/>
													)
												}
											</>
										) :
										(
											this.props.search_result.error_limit  ?
											(
												!this.state.error_limit_send &&
												(
													<div className="col booking_limit">
														<img src="../../wp-content/plugins/booking-form/images/gecko-headset.png"
															alt="gecko headset"
															 className="alignleft" />
														<p style={{color: "#d63545", fontSize: "18px"}}>
															<strong>Opps, our system seems to be busy?!</strong>
														</p>
														<p>Sorry about this. You can go back and try again or, leave your name and number and we'll
														call you back immediately to finalize!</p>
														<div className="col-md-8">
															<div className="row">
																<div className="form-group col-md-6 limit-fields fake-placeholder">
																	<div className="placeholder" style={{display: "block"}}>
																		<label htmlFor="limit_name">Name</label>
																		<span className="star">*</span>
																	</div>
																	<input className="form-control required"
																		type="text" name="limit_name" />
																</div>
																<div className="form-group col-md-6 limit-fields fake-placeholder">
																	<div className="placeholder" style={{display: "block"}}>
																		<label htmlFor="limit_phone">Phone</label>
																		<span className="star">*</span>
																	</div>
																	<input className="form-control required"
																		type="text" name="limit_phone" />
																</div>
															</div>
															<div className="row justify-content-center">
																<div className="form-group col-auto limit-fields">
																	<input type="button" className="btn btn-success"
																		   value="Send" onClick={this.onSendErrorLimit} />
																</div>
															</div>
														</div>
													</div>
												)
											) :
											(
												<div className="col">
													<img src="../../wp-content/plugins/booking-form/images/gecko-headset.png"
														alt="gecko headset"
														className="alignleft" />
													<p style={{color: "#d63545", fontSize: "18px"}}>
														<strong>Opps, that location is currently booked!</strong>
													</p>
													<p>Sorry, the vehicles at your chosen location are out on hire during your selected
													time, is it possible to consider other dates and times?
													</p>
													<p>If not, I'm sure we can arrange a suitable hire at one of our
													other convenient hire locations nearby. We'll even give you 100
													extra free kms with your booking, if you call us right now, and
													quote the discount code <b style={{color: "#d63545"}}>GeckoBooked</b> when making your
													booking at the new location.</p>
													<p>We look forward to handling your hire vehicle needs.</p>
													<p>
														<a href="tel:1300826883" className="btn btn-green">Call 1300 826 883</a>
													</p>
												</div>
											)
										)
									}
								</div>
							) :
							(
								<div className="col">
									<img src="../../wp-content/plugins/booking-form/images/gecko-headset.png"
										alt="gecko headset"
										className="alignleft" />
									<p style={{color: "#d63545", fontSize: "18px"}}>
										<strong>Opps, that location is currently booked!</strong>
									</p>
									<p>Sorry, the vehicles at your chosen location are out on hire during your selected time, is it possible to
									consider other dates and times?</p>
									<p>If not, I'm sure we can arrange a suitable hire at one of our other convenient
									hire locations nearby. We'll even give you 100 extra free kms with your booking, if
									you call us right now, and quote the discount code <b style={{color: "#d63545"}}>GeckoBooked</b> when making your booking at the new
									location.</p>
									<p>We look forward to handling your hire vehicle needs.</p>
									<p>
										<a href="tel:1300826883" className="btn btn-green">Call 1300 826 883</a>
									</p>
								</div>
							)
					}
				</div>
			</div>
		</>);
	}
}

export default SearchResultPage;

class AvailableVehicles extends Component {
	constructor(props) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
		this.onChangeVehicleGroup = this.onChangeVehicleGroup.bind(this);

		this.state = {
			category_group_filter: this.props.category_group_filter
		};
	}

	callbackRentalCarPrices(resp, t) {
		let to_show = t.props.to_show;
		let prices = resp.prices;
		to_show.data_original_title = 'All vehicles come with standard insurance with Excess of $7500 in the event of an accident or claim. Reducing your excess liability coverage to $1000 for your hire period costs $' + prices.premium_insurance + ' per day.';
		to_show.insurance_cover = prices.premium_insurance;
		to_show.span_roadside_assistance = prices.roadside_assistance_price;
		if (prices.allowance > 0)
			to_show.kms = prices.allowance;
		to_show.span_towing_surcharge = prices.towing_surcharge_price;
		t.props.handleSetShowData(to_show);
	}

	onSelect(id, name, vehicle_payment) {
		this.props.handleSetSomeBlock('scroll_to_element', 'id_extras_page');

		this.props.handleSetHireIncludes(id, name, '', '', '', vehicle_payment);
		getRentalCarPrices(this.props.booking_form_data.booking, this.callbackRentalCarPrices, this);
	}

	onChangeVehicleGroup(e) {
		if ($('.vehicles .available_variant_closest_date').hasClass('slick-initialized'))
			$('.vehicles .available_variant_closest_date').slick('unslick');

		if ($('.vehicles .available_variant_closest').hasClass('slick-initialized'))
			$('.vehicles .available_variant_closest').slick('unslick');

		let vehicles_filtered = [];
		let vehicles_closest_date_filtered = [];
		let vehicles_closest_filtered = [];

		let category = parseInt(e.target.value);
		this.setState({category_group_filter: category});
		this.props.handleSetSomeBlock('category_group_filter', category);

		if (category > 0) {
			let bf_category_categories = window.bf_category_categories;
			if (Object.keys(bf_category_categories).length > 0 && Object.keys(bf_category_categories[category]).length > 0) {
				if (Object.keys(this.props.vehicles).length > 0) {
					let i = 0;
					Object.keys(this.props.vehicles).map((k) => {
						if (bf_category_categories[category].includes(this.props.vehicles[k].vehiclecategoryid)) {
							vehicles_filtered[i] = this.props.vehicles[k];
							i++;
						}
					});
				}

				if (Object.keys(this.props.vehicles_closest_date).length > 0) {
					let i = 0;
					Object.keys(this.props.vehicles_closest_date).map((k) => {
						if (bf_category_categories[category].includes(this.props.vehicles_closest_date[k].vehiclecategoryid)) {
							vehicles_closest_date_filtered[k] = this.props.vehicles_closest_date[k];
							i++;
						}
					});
				}

				if (Object.keys(this.props.vehicles_closest).length > 0) {
					let i = 0;
					Object.keys(this.props.vehicles_closest).map((k) => {
						if (bf_category_categories[category].includes(this.props.vehicles_closest[k].vehiclecategoryid)) {
							vehicles_closest_filtered[k] = this.props.vehicles_closest[k];
							i++;
						}
					});
				}
			}
		}
		else if (category === 0) {
			vehicles_filtered = this.props.vehicles;
			vehicles_closest_date_filtered = this.props.vehicles_closest_date;
			vehicles_closest_filtered = this.props.vehicles_closest;
		}

		let search_result_filter = {
			'vehicles': (Object.keys(vehicles_filtered).length) ? vehicles_filtered : {},
			'vehicles_closest_date': (Object.keys(vehicles_closest_date_filtered).length) ? vehicles_closest_date_filtered : {},
			'vehicles_closest': (Object.keys(vehicles_closest_filtered).length) ? vehicles_closest_filtered : {}
		};

		this.props.handleSetFilterResult(true, false, search_result_filter, category);
	}

	render() {
//		let initial_data = {};
		let booking = this.props.booking_form_data.booking;
		let category_groups = window.bf_category_groups;
		let vehicles = this.props.vehicles_filter;

		return (<>
			<RedirectOnlyHome />

			{
				Object.keys(vehicles).length ?
				(
					<>
						<div className="row match_vehicles justify-content-end" style={{marginBottom:"15px", textAlign:"left"}}>
							<div className="col-md-7">
								<h2>Your Available Vehicles</h2>
							</div>
							<div className="col-md-5">
								<div className="row match_vehicles_filter">
									<div className="col-sm-5" style={{paddingTop: "5px",paddingBottom: "5px"}}>Filter results by:</div>
									<div className="col-sm-7">
										<select className="form-control"
												name="category_group_filter"
												onChange={this.onChangeVehicleGroup}
												value={this.state.category_group_filter}>
											<option value="0" key="0"></option>
											{Object.keys(category_groups).map((keyName) => (
												<option value={category_groups[keyName]} key={category_groups[keyName]}>{keyName}</option>
											))}
										</select>
									</div>
								</div>
							</div>
						</div>

						<div className="row match_vehicles" style={ {marginBottom: "15px"} }>
							{
								vehicles.map((v) => {
									const truck_picture = {
										backgroundImage:`url(${v.picture})`,
										zIndex: '100'
									};
									return (
										<div className="vehicle col-md-6" id={v.id} style={{marginBottom: "15px"}} key={v.id}>
											<div className="row" style={{backgroundColor: "#f0f0f0",marginLeft: "0px",marginRight: "0px", borderRadius:"48px"}}>
												<div className="offset-md-3 col-md-6 truck-picture" style={truck_picture}></div><div className="col-md-6"></div>
												<div className="col-md-12">
													<h3 style={{textAlign:'center'}}>{v.name}</h3>
													<p className="description">{v.description}</p>
													<p>
														{
															v.volume &&
																<span className="volume"><i className="fas fa-box-open"></i>{v.volume}</span>
														}
														<span className="passengers"><i className="fas fa-user"></i>{v.passengers}</span>
													</p>
													<p className="description additional-info">{v.additional_descr}</p>
													<div className={'bottomRow'}>
														<span><span className="price">{v.price}</span>Per Day</span>
														<input type="button"
															   className={'btn btn-large btn-green-border'+ ((v.id === booking.vehicle && booking.alternative_location === '' && booking.alternative_pickupdate === '' ) ? ' active' : '')}
															   value="Select"
															   onClick={()=>{this.onSelect(v.id, v.name, v.vehicle_payment)}}
														/>
													</div>
												</div>
											</div>
										</div>
										)
									}
								)
							}
						</div>
					</>
				) :
				(
					<div className="row" style={{marginBottom: "15px"}}>
						<div className="col-12">
							<img src="../../wp-content/plugins/booking-form/images/gecko-headset.png"
								 alt="gecko headset"
								 className="alignleft" />
							<p style={{color: "#d63545", fontSize: "18px"}}>
								<strong>
									Opps,{((this.props.category_group_filter === 0) ? (' that location is currently booked') : (' the vehicles at this location are currently booked'))}!
								</strong>
							</p>
							{
								(this.props.category_group_filter > 0 && (Object.keys(this.props.vehicles).length || Object.keys(this.props.vehicles_closest_date).length || Object.keys(this.props.vehicles_closest).length)) &&
								<p>
									Filter results by : <select className="form-control"
																name="category_group_filter"
																onChange={this.onChangeVehicleGroup}
																value={this.state.category_group_filter}
																style={{width: "unset", display: "unset"}}>
									<option value="0" key="0"></option>
									{Object.keys(category_groups).map((keyName) => (
										<option value={category_groups[keyName]}
												key={category_groups[keyName]}>{keyName}</option>
									))}
								</select>
								</p>
							}
							<p>Sorry, the vehicles at your chosen location are out on hire during your selected time, is it possible to
								consider other dates and times?
							</p>
							<p>
								If not, I'm sure we can arrange a suitable hire at one of our other convenient
								hire locations nearby. We'll even give you 100 extra free kms with your booking, if
								you call us right now, and quote the discount code <b style={{color: "#d63545"}}>GeckoBooked</b> when making your booking at the new
								location.
							</p>
							<p>
								We look forward to handling your hire vehicle needs.
							</p>
							<p>
								<a href="tel:1300826883" className="btn btn-green">Call 1300 826 883</a>
							</p>
						</div>
					</div>
				)
			}

		</>);
	}
}

class AvailableVehiclesClosestDate extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		$('.vehicles .available_variant_closest_date').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
//			dots: true,
//			dotsClass: 'slick-dots',
			prevArrow: $('.arrow-prev1'),
			nextArrow: $('.arrow-next1'),
			responsive: [
				{breakpoint: 768, settings: {slidesToShow: 2, slidesToScroll: 1}},
				{breakpoint: 640, settings: {slidesToShow: 1, slidesToScroll: 1}}
			]
		});
	}

	componentDidUpdate(previousProps) {
		if (this.props.category_group_filter !== previousProps.category_group_filter) {
			if ($('.vehicles .available_variant_closest_date').hasClass('slick-initialized'))
				$('.vehicles .available_variant_closest_date').slick('unslick');

			$('.vehicles .available_variant_closest_date').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: true,
				dotsClass: 'slick-dots',
				prevArrow: '<button type="button" class="slick-prev">Previous</button>',
				nextArrow: '<button type="button" class="slick-next">Next</button>',
				responsive: [
					{breakpoint: 768, settings: {slidesToShow: 2, slidesToScroll: 1}},
					{breakpoint: 640, settings: {slidesToShow: 1, slidesToScroll: 1}}
				]
			});
		}
	}

	componentWillUnmount() {
		this.destroySliders();
	}

	destroySliders() {
		if ($('.vehicles .available_variant_closest_date').hasClass('slick-initialized'))
			$('.vehicles .available_variant_closest_date').slick('unslick');
	}

	callbackRentalCarPrices(resp, t) {
		let to_show = t.props.to_show;
		let prices = resp.prices;
		to_show.data_original_title = 'All vehicles come with standard insurance with Excess of $7500 in the event of an accident or claim. Reducing your excess liability coverage to $1000 for your hire period costs $' + prices.premium_insurance + ' per day.';
		to_show.insurance_cover = prices.premium_insurance;
		to_show.span_roadside_assistance = prices.roadside_assistance_price;
		if (prices.allowance > 0)
			to_show.kms = prices.allowance;
		to_show.span_towing_surcharge = prices.towing_surcharge_price;

		t.props.handleSetShowData(to_show);
	}

	onSelect(id, name, pickup_date, return_date, vehicle_payment) {
		this.props.handleSetSomeBlock('scroll_to_element', 'id_extras_page');
		this.props.handleSetHireIncludes(id, name, '', pickup_date, return_date, vehicle_payment);
		getRentalCarPrices(this.props.booking_form_data.booking, this.callbackRentalCarPrices, this);
	}

	render() {
		let booking = this.props.booking_form_data.booking;
		let vehicles_closest_date = this.props.vehicles_closest_date_filter;
		return (<>
			<RedirectOnlyHome />
			{
				(vehicles_closest_date !== undefined && Object.keys(vehicles_closest_date).length) &&
				(
					<div className="row justify-content-center" style={{marginBottom: "15px"}}>
						<div className="col-12 p-3 m-2 rounded">
							<div className="row">
								<div className="col text-center">
									<h2>Alternate Date Options</h2>
								</div>
							</div>
							<div className="available_variant_closest_date">
							{
								Object.keys(vehicles_closest_date).map((v,i) => {
									const truck_picture = {
										backgroundImage:`url(${vehicles_closest_date[v].picture})`,
										zIndex: '100'
									};
									const location = getLocationDetailsById( +booking.pickuplocationid );
									return (
										<div key={i} className="available_variant_vehicle">
											<div className="col">
												<div className="row">
													<div className="offset-md-1 col-md-10 truck-picture" style={truck_picture}></div>
													{ location && location.phone
														&& (
															<div className="offset-md-1 col-md-10 pl-1 mt-2">
																<div className={'btn btn-label btn-red'}><i className="icon-location2"></i>{ location.phone }-<span className={'districtName'}>{location.address.city}</span> </div>
															</div>
														)
													}
													<div className="col-md-12 available_variant_vehicle_text">
														<h3 className="available_variant_vehicle_title">
															<i className="icon3-sports-car available_variant_vehicle_i"></i>
															{vehicles_closest_date[v].name}
														</h3>
														<div><i className="icon-clock2 available_variant_begin_i"></i> {vehicles_closest_date[v].pickupdate}</div>
														<p><i className="icon-clock2 available_variant_end_i"></i> {vehicles_closest_date[v].dropoffdate}</p>
														<div className={'bottomRow'}>
															<div>
																{ vehicles_closest_date[v].price && (
																	<span><span className="price">{vehicles_closest_date[v].price}</span>Per Day</span>
																)}
															</div>
															<input type="button"
																   className={'btn btn-large btn-green-border'+ ((vehicles_closest_date[v].id === booking.vehicle && booking.alternative_location === "" && booking.alternative_pickupdate === vehicles_closest_date[v]._pickupdate) ? ' active' : '')}
																   value="Select"
																   onClick={()=>{this.onSelect(vehicles_closest_date[v].id, vehicles_closest_date[v].name, vehicles_closest_date[v]._pickupdate, vehicles_closest_date[v]._dropoffdate, vehicles_closest_date[v].vehicle_payment)}}
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									)
								})
							}
							</div>
						</div>
						<div className={'col slick-arrows'} style={{textAlign:'center'}}>
							<button type="button"
									className={'arrow-prev1 btn btn-round mr-1'}
									value="Select"
							><i className={'fa fa-arrow-left'}></i>
							</button>
							<button type="button"
									className={'arrow-next1 btn btn-round btn-red ml-1'}
									value="Select"
							><i className={'fa fa-arrow-right'}></i>
							</button>
						</div>
					</div>
				)
			}
		</>);
	}
}

class AvailableVehiclesClosest extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		$('.vehicles .available_variant_closest').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			//dots: true,
			//dotsClass: 'slick-dots',
			prevArrow: $('.arrow-prev2'),
			nextArrow: $('.arrow-next2'),
			responsive: [
				{breakpoint: 768, settings: {slidesToShow: 2, slidesToScroll: 1}},
				{breakpoint: 640, settings: {slidesToShow: 1, slidesToScroll: 1}}
			]
		});
	}

	componentDidUpdate(previousProps) {
		if (this.props.category_group_filter !== previousProps.category_group_filter) {
			if ($('.vehicles .available_variant_closest').hasClass('slick-initialized'))
				$('.vehicles .available_variant_closest').slick('unslick');

			$('.vehicles .available_variant_closest').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: true,
				dotsClass: 'slick-dots',
				prevArrow: '<button type="button" class="slick-prev">Previous</button>',
				nextArrow: '<button type="button" class="slick-next">Next</button>',
				responsive: [
					{breakpoint: 768, settings: {slidesToShow: 2, slidesToScroll: 1}},
					{breakpoint: 640, settings: {slidesToShow: 1, slidesToScroll: 1}}
				]
			});
		}
	}

	componentWillUnmount() {
		this.destroySliders();
	}

	destroySliders() {
		if ($('.vehicles .available_variant_closest').hasClass('slick-initialized'))
			$('.vehicles .available_variant_closest').slick('unslick');
	}

	callbackRentalCarPrices(resp, t) {
		let to_show = t.props.to_show;
		let prices = resp.prices;
		to_show.data_original_title = 'All vehicles come with standard insurance with Excess of $7500 in the event of an accident or claim. Reducing your excess liability coverage to $1000 for your hire period costs $' + prices.premium_insurance + ' per day.';
		to_show.insurance_cover = prices.premium_insurance;
		to_show.span_roadside_assistance = prices.roadside_assistance_price;
		if (prices.allowance > 0)
			to_show.kms = prices.allowance;
		to_show.span_towing_surcharge = prices.towing_surcharge_price;

		t.props.handleSetShowData(to_show);
	}

	onSelect(id, name, location_id, vehicle_payment) {
		this.props.handleSetSomeBlock('scroll_to_element', 'id_extras_page');

		this.props.handleSetHireIncludes(id, name, location_id, '', '', vehicle_payment);
		getRentalCarPrices(this.props.booking_form_data.booking, this.callbackRentalCarPrices, this);
	}

	render() {
//		let initial_data = window.localStorage.getItem('initial_data');
		let booking = this.props.booking_form_data.booking;
		let vehicles_closest = this.props.vehicles_closest_filter;
		const detailed_locations = window.bf_detailed
		return (<>
			<RedirectOnlyHome />
			{
				(vehicles_closest !== undefined && Object.keys(vehicles_closest).length) &&
				(
					<div className="row justify-content-center" style={{marginBottom: "15px"}}>
						<div className="col-12 p-3 m-2 rounded">
							<div className="row">
								<div className="col text-center">
									<h2>Nearest Alternate Options</h2>
								</div>
							</div>
							<div className="available_variant_closest">
								{
									Object.keys(vehicles_closest).map((v,i) => {
										const truck_picture = {
											backgroundImage:`url(${vehicles_closest[v].picture})`,
											zIndex: '100'
										};
										const location = getLocationDetailsById(vehicles_closest[v].location_id);
										return (
											<div key={i+50} className="available_variant_vehicle">
												<div className="col">
													<div className="row">
														<div className="offset-md-1 col-md-10 truck-picture" style={truck_picture}></div>
														<div className="offset-md-1 col-md-10 pl-1 mt-2">
															<div className={'btn btn-label bt' +
																'n-red'}><i className="icon-location2"></i>{location.phone}-<span className={'districtName'}>{location.address.city}</span> </div>
														</div>
														<div className="col-md-12 available_variant_vehicle_text">
															<h3 className="available_variant_vehicle_title">
																<i className="icon3-sports-car available_variant_vehicle_i"></i>
																{vehicles_closest[v].name}
															</h3>
															<div><i className="icon-clock2 available_variant_begin_i"></i> {vehicles_closest[v].pickupdate}</div>
															<p><i className="icon-clock2 available_variant_end_i"></i> {vehicles_closest[v].dropoffdate}</p>
															<div className={'bottomRow'}>
																<div>
																	{ vehicles_closest[v].price && (
																		<span><span className="price">{vehicles_closest[v].price}</span>Per Day</span>
																	)}
																</div>
																<input type="button"
																	   className={'btn btn-large btn-green-border'+ ((vehicles_closest[v].id === booking.vehicle && booking.alternative_location === vehicles_closest[v].location_id && booking.alternative_pickupdate === "") ? ' active' : '')}
																	   onClick={()=>{this.onSelect(vehicles_closest[v].id, vehicles_closest[v].name, vehicles_closest[v].location_id, vehicles_closest[v].vehicle_payment)}}
																	   value="Select"
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
										)
									})
								}
							</div>
						</div>
						<div className={'col slick-arrows'} style={{textAlign:'center'}}>
							<button type='button'
									className={'arrow-prev2 btn btn-round mr-1'}
									value='Select'
							><i className={'fa fa-arrow-left'}></i>
							</button>
							<button type='button'
									className={'arrow-next2 btn btn-round btn-red ml-1'}
									value='Select'
							><i className={'fa fa-arrow-right'}></i>
							</button>
						</div>
					</div>
				)
			}
		</>);
	}
}
